module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/scotts-for-storage-logo-30ac899f9ae7fde26fecb9f4ff022424.png";